import React from "react";
import moment from "moment";
import { Comment, Image } from "semantic-ui-react";
import ConnectUserOnClick from "../MetaPanel/ConnectUserOnClick";
import ProfanityWords from "./ProfanityWords";

const isOwnMessage = (message, user) => {
  return message.user.id === user.uid ? "message__self" : "";
};

const isImage = (message) => {
  return message.hasOwnProperty("image") && !message.hasOwnProperty("content");
};

const profanity = (content) => {
  var index, value;
  var match = false;
  for (index = 0; index < ProfanityWords.length; ++index) {
    value = ProfanityWords[index];
    if (content.includes(value)) {
      match = true;
      break;
    }
  }
  return match;
};

const timeFromNow = (timestamp) => moment(timestamp).fromNow();

const Message = ({ message, user }) => (
  <Comment>
    <Comment.Avatar src={message.user.avatar} />
    <Comment.Content className={isOwnMessage(message, user)}>
      <Comment.Author as="a">
        {user.uid === message.user.id ? (
          "You"
        ) : (
          <ConnectUserOnClick replacePage={true} user={message.user} />
        )}
      </Comment.Author>
      <Comment.Metadata>{timeFromNow(message.timestamp)}</Comment.Metadata>
      {isImage(message) ? (
        <Image src={message.image} className="message__image" />
      ) : (
        <div>
          {profanity(message.content) ? (
            <Comment.Text style={{ color: "red" }}>
              <strong>You are not allowed to use foul words here. </strong>
              Please refrain from such activities.
            </Comment.Text>
          ) : (
            <Comment.Text>{message.content}</Comment.Text>
          )}
        </div>
      )}
    </Comment.Content>
  </Comment>
);

export default Message;



// WEBPACK FOOTER //
// ./src/components/Messages/Message.js